import React from 'react'
import { Modal } from '@scuf/common'
import AssetManagementTable from '../../../../AssetManagementTable'
import { ModalWrap, ModalTitle } from './mobile-os-modal.styles'

export const columns = [
  { field: 'key', translation: 'AssetManagementTable_osVersion', render: null },
  { field: 'value', translation: 'AssetManagementTable_osVersionCount', render: null },
  { field: 'percentage', translation: 'AssetManagementTable_percentage', render: ({ value }) => <p>{value} %</p> }
]

const MobileOsModal = ({ data, t }) => (
  <ModalWrap>
    <ModalTitle>{t('MobileOsVersion_title')}</ModalTitle>
    <Modal.Content>
      <AssetManagementTable
        columns={columns}
        data={data}
        disableRowClick
        fileName={t('MobileOsVersion_title')}
      />
    </Modal.Content>
  </ModalWrap>
)

export default MobileOsModal
